/* eslint-disable */
const hash = {
  "en-US": "c1404e4e",
  "de-DE": "67999916",
  "es-ES": "e0462511",
  "fr-FR": "cc339a07",
  "id-ID": "86d3b129",
  "it-IT": "42c47fe7",
  "jp-JP": "5e424809",
  "ko-KO": "47b8d385",
  "nl-NL": "3d8c9ed0",
  "pl-PL": "7acdad1a",
  "pt-PT": "d5438755",
  "ru-RU": "8d8a5be1",
  "sv-SE": "cd022470",
  "tr-TR": "cc4bdfc2",
  "vi-VN": "6449e695",
  "zh-CN": "f0aa93a0",
  "zh-TW": "1d479dfa",
  "avatars": "fb16c7a2",
  "control": "82b2a82c",
  "plan-details": "24f2475e",
  "gov-EN": "cce45666",
  "en-GB": "c4a88fa3"
}
export default hash
